import { colors as Colors, spacing as Spacing } from "material-ui/styles";
import { fade } from "material-ui/utils/colorManipulator";

export default {
  getThemeForTenant(tenant = {}) {
    const palette = Object.assign(
      {},
      {
        primary1Color: "#EC3431",
        primary2Color: Colors.grey500,
        primary3Color: Colors.lightBlack, //Colors.deepOrange100,
        accent1Color: "#EC3431", //Colors.deepOrange500,
        accent2Color: Colors.grey300,
        accent3Color: Colors.grey100,
        textColor: Colors.grey900,
        canvasColor: Colors.white,
        borderColor: Colors.grey300,
        disabledColor: Colors.grey500,
        alternateTextColor: Colors.white
      },
      tenant.palette
    );

    if (tenant.invert_colors_alt) {
      palette.primary1Color = palette.accent1Color;
    }

    return {
      spacing: Spacing,
      fontFamily: tenant.sundance_login
        ? "MonumentGrotesk, sans-serif"
        : tenant.font_proxima_nova
        ? "proxima-nova, sans-serif"
        : "Lato, sans-serif",
      palette: palette,
      button: {
        minWidth: 5,
        fontWeight: 700,
        ...(tenant.sundance_login
          ? {
              fontWeight: null
            }
          : null)
      },
      raisedButton: {
        primaryColor: palette.accent1Color,
        secondaryColor: palette.primary1Color,
        primaryTextColor: tenant.invert_colors ? "#000" : undefined,
        fontWeight: 700,
        ...(tenant.sundance_login
          ? {
              fontWeight: null
            }
          : null)
      },
      flatButton: {
        color: Colors.white,
        primaryTextColor: tenant.invert_colors ? "#000" : palette.accent1Color,
        secondaryColor: palette.primary1Color,
        fontWeight: 700,
        ...(tenant.sundance_login
          ? {
              fontWeight: null
            }
          : null)
      },
      toggle: {
        thumbOnColor: palette.accent1Color,
        trackOnColor: fade(palette.accent1Color, 0.5)
      },
      appBar: {
        textColor: tenant.invert_colors_alt ? "#000" : undefined,
        color: tenant.palette.primary1Color || palette.primary1Color
      },
      ...(tenant.sundance_login
        ? {
            borderRadius: 4
          }
        : null)
    };
  }
};



// WEBPACK FOOTER //
// ./src/app/theme.js